import React from 'react';
import { BaseHistoryEntryData, PersonData } from 'nekst-api';
import RecordLayout, { RecordLayoutProps } from './RecordLayout';
import PersonLink from './PersonLink';
import { HistoryEventIconType } from './HistoryEventIcon';

interface ClientPortalInvitationAcceptedData extends BaseHistoryEntryData {
  contact: PersonData;
}

export default function ClientPortalInvitationAcceptedRecordLayout(
  props: RecordLayoutProps<ClientPortalInvitationAcceptedData>,
) {
  return (
    <RecordLayout
      text={(
        <>
          <PersonLink person={props.record.data.contact} />
          {' accepted the Client Portal invitation.'}
        </>
      )}
      date={props.record.when}
      iconType={HistoryEventIconType.PORTAL_INVITATION_ACCEPTED}
    />
  );
}
